var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{class:{ 'fixed-header': _vm.isFixed }}),_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c(Component,{key:_vm.key,tag:"component"})]}}])}),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }